var map = {
	"./2dmap/pop_close_open.png": "tOA6",
	"./2dmap_eyes/pop_close_open.png": "BHkC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MOzB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/pop_close_open\.png$
// module id = MOzB
// module chunks = 2